import { css, html, LitElement } from "lit";

import "../components/navbar";
import "../components/landing";
import "../components/flight";

import {
  fetchFlightSessionsByUserId,
  fetchLandingsByUserId,
  fetchUserById,
} from "../common/api";
import { setTitle, trackPage } from "../common/client";
import { skillLevels } from "../common/exp";
import { getPlayerNameColor } from "../common/utils";
import { websiteStyles } from "../styles/website";

export class UserPage extends LitElement {
  constructor() {
    super();
    this.userId = "";
    /** @type {DiscordUserData} */
    this.userData = null;
    /** @type {LandingRateData[]} */
    this.landings = [];
    /** @type {Array<any>} */
    this.flightSessions = [];

    this.timer = null;
  }

  static styles = [
    websiteStyles,
    css`
      :host {
        display: block;
        width: 100vw;
        height: 100vh;
        background: #FFF;
        color: black;
        padding-top: 70px;
        text-align: center;
      }
      .content {
        text-align: left;
      }
      .player-icon {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 20px;
      }
      .xp-bar {
        width: 100%;
        height: 20px;
        background: #eee;
        border-radius: 10px;
        overflow: hidden;
        margin-top: 5px;
        margin-bottom: 5px;
      }
      .xp-fill {
        height: 100%;
        background: #3498db;
      }
      .flight-link {
        color: rgb(65, 138, 207);
      }
      .flight-link:hover {
        text-decoration: underline;
      }
    `,
  ];

  async loadData() {
    this.userId = window.location.pathname.split("/").pop();
    this.userData = await fetchUserById(this.userId);
    this.landings = await fetchLandingsByUserId(this.userId);
    this.flightSessions = await fetchFlightSessionsByUserId(this.userId);
    this.requestUpdate();
  }

  connectedCallback() {
    super.connectedCallback();

    trackPage();
    setTitle("User Page");

    this.loadData();
    this.timer = setInterval(() => this.loadData(), 60000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  render() {
    if (!this.userData) {
      return html`<navbar-component></navbar-component>        
      `;
    }
    const lastLevelXp = skillLevels[this.userData.level] || 0;
    const nextLevelXp =
      skillLevels[this.userData.level + 1] || lastLevelXp + 1000;
    console.log(
      `XP Details: Current XP: ${this.userData.xp}, Last Level XP: ${lastLevelXp}, Next Level XP: ${nextLevelXp}`
    );

    /** @type {Array<{type: string, data: any, timestamp: number}>} */
    const log = [];
    this.landings.forEach((landing) => {
      log.push({
        type: "landing",
        data: landing,
        timestamp: landing.timestamp,
      });
    });
    this.flightSessions.forEach((session) => {
      log.push({
        type: "flight",
        data: session,
        timestamp: session.startedAt,
      });
    });
    log.sort((a, b) => b.timestamp - a.timestamp);

    return html`<navbar-component></navbar-component>
      <section>
      <div class="content">
        <h1><img src="${this.userData.avatar ? this.userData.avatar : "./images/logo.jpeg"}" alt="${this.userData.username}" class="player-icon" /> <span class="username" style="color: ${getPlayerNameColor(this.userData.xp)}">${this.userData.username}</span>
        </h1>
          <p><b>Total Miles Flown:</b> ${Math.round(this.userData.totalMiles).toLocaleString()}</p>
          <p><div class="xp-bar"><div class="xp-fill" style="width: ${((this.userData.xp - lastLevelXp) / (nextLevelXp - lastLevelXp)) * 100}%"></div></div> Level ${this.userData.level}<div style="float:right">${Math.round(this.userData.xp - lastLevelXp).toLocaleString()} / ${Math.round(nextLevelXp - lastLevelXp).toLocaleString()} XP</div></p>
          <h2>Recent Activity</h2>
          ${log.map((entry) => {
            if (entry.type === "landing") {
              return html`<landing-component .landing=${entry.data}></landing-component>`;
            } else if (entry.type === "flight") {
              return html`<flight-component .flight=${entry.data}></flight-component>`;
            }
            return null;
          })}
        </div>
      </section>
      `;
  }
}

customElements.define("user-page", UserPage);
